import {AuthTokens} from '../types';
import {hasTokenExpired} from './hasTokenExpired';

export const hasValidAccessToken = (tokens: AuthTokens | undefined) =>
  tokens !== undefined && !hasTokenExpired(tokens.accessToken);
